export interface CommonState {
    masterData: Record<string, any[]>;
    masterDataLoaded: boolean;
    businessEntities: Record<string, any[]>;
    businessEntitiesLoaded: boolean;
    allUsers: any[];
    allInternalUsers: any[];
    allRoles: any[];
    allAE: any[];
    allRec: any[];
    allTeamLead: any[];
    allClients: any[];
    allCurrency: any[];
    qbUsers: any[];
    loading: boolean;
    error: string | null;
}

export const initialCommonState: CommonState = {
    masterData: {},
    masterDataLoaded: false,
    businessEntities: {},
    businessEntitiesLoaded: false,
    allUsers: [],
    allInternalUsers: [],
    allRoles: [],
    allAE: [],
    allRec: [],
    allTeamLead: [],
    allClients: [],
    allCurrency: [],
    qbUsers: [],
    loading: false,
    error: null,
};
